import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, BrowserRouter } from 'react-router-dom';
import AllRoutes from './routes/allRoutes';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
        <Toaster position="top-right" reverseOrder={false} />
        <AllRoutes />
    </>
  );
}

export default App;
